import { Station } from "../types";

let _all: Station[] = [];
const _byId = new Map<string, Station>();
type Listener = (stations: Station[]) => void;
const listeners = new Set<Listener>();

export function setStations(stations: Station[]) {
	_all = stations.filter(o => o.Enabled);
	_byId.clear();
	for (const s of _all) _byId.set(s.Id.toUpperCase(), s);
	listeners.forEach(l => l(_all));
}

export function getStations(): Station[] {
	return _all;
}

export function getStationById(id: string | undefined): Station | undefined {
	if (id === undefined) {
		return undefined;
	}
	return _byId.get(id.toUpperCase());
}

export function subscribe(listener: Listener) {
	listeners.add(listener);
	return () => listeners.delete(listener);
}
